import Calendar from 'react-calendar';
import styled from 'styled-components';

import { colours, fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

export const StyledCalendar = styled(Calendar)`
  div,
  button {
    ${fontStyleRegular}
  }

  .react-calendar__tile-away-dates {
    background-color: rgba(0, 110, 220, 0.5);
  }

  &.react-calendar {
    width: 100%;
    border: 1px solid ${colours.Shades.TintBlue10};
  }
`;
